import {
  Box,
  Text,
  Button,
  Flex
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar";

export default function BusinessAppStart() {
  const navigate = useNavigate();

  return (
    <Box minHeight="100vh" display="flex" flexDirection="column" bg="white">
      <Navbar />
      {/* Header */}
      <Box
        bg="#00C49A"
        height="80px"
        display="flex"
        alignItems="flex-end"
        justifyContent="center"
        pb={2}
      >
        <Text fontSize="lg" fontWeight="bold" color="black">
          RESOURCES 
        </Text>
      </Box>

      {/* Main Content */}
      <Box
        flex="1"
        overflowY={"auto"}
        px={4}
        pt={6}
        pb="160px"
        display="flex"
        justifyContent="center"
        minHeight={{ base: "auto", md: "calc(100vh - 200px)" }}
        position="relative"
      >
        <Box width="100%" maxW="420px">
          {/* Back Arrow */}

          {/* Title */}
          <Text fontSize="xl" fontWeight="bold" textAlign="center" mb={2}>
           Pilot Small Business
            <br />
            Resource Information
          </Text>

          {/* Description */}
          <Box mb={6} px={2}>
            <Text fontSize="sm" color="gray.600" textAlign="left" lineHeight="short">
              Thank you for considering our loan services. <br />
              Please review and acknowledge the terms below:
            </Text>
          </Box>

          {/* Loan Amount Section */}
          <Text fontWeight="bold" color="#00C49A" mb={1}>
            Loan Amount
          </Text>
          <Text fontSize="md" mb={6}>
          You may request a loan amount of <b>5000</b>.
          </Text>

          {/* Loan Repayments Section */}
          <Text fontWeight="bold" color="#00C49A" mt={50} mb={1}>
            Loan Repayments
          </Text>
          <Text fontSize="md" mb={10}>
          To receive your loan, you must pay one time origination fee of <b>500</b> for each loan, and the loan must be repaid within <b>one month</b> of issuance.
          </Text>

          {/* Final Note */}
          <Text fontSize="sm" color="gray.500" fontStyle="italic" mb={12}>
            After reviewing the loan information, you may start your application for a loan below.
          </Text>

          {/* Apply Button */}
          <Box textAlign="center" mb={12}>
            <Button
              bg="#00C49A"
              color="white"
              fontWeight="bold"
              fontSize="md"
              borderRadius="2xl"
              px={16}
              py={10}
              _hover={{ bg: "#00B388" }}
              onClick={() => navigate("/business-app-1")}
            >
              Apply Now!
            </Button>
          </Box>

          {/* Go Back Link - bottom left aligned */}
          <Flex
            align="center"
            justifyContent="flex-start"
            color="black"
            cursor="pointer"
            onClick={() => navigate(-1)}
            position="absolute"
            bottom="95px"
            left="16px"
          >
          </Flex>
        </Box>
      </Box>

      {/* Bottom Nav */}
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        bg="white"
        py={3}
        justifyContent="space-around"
        borderTop="2px solid black"
        zIndex={5}
      >
      </Flex>
    </Box>
  );
}